import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useServerError } from "../Utils/handleServerError";
import WithdrawService from "../Services/WithdrawService";
import { setWithdraws, removeWithdraw } from "../Redux/slices/dashboardSlice";
import { toast } from "react-toastify";

export const Withdrawals = () => {
  const style = {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    paddingBottom: "3rem",
    overflow: "hidden",
    width: "100%",
  };

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const { tokens } = useSelector((state) => state.authSlice);
  const { user_withdraws } = useSelector((state) => state.dashboardSlice);

  const [error, setError] = useState(null);

  useServerError(error);

  function openErrorMessage(error) {
    setError(error);

    setTimeout(() => {
      setError(null);
    }, 4000);
  }

  async function getUserWithdraws() {
    if (loading) return;

    setLoading(true);

    try {
      const res = await WithdrawService.get_user_withdraws(tokens);

      if (res.data.status) {
        dispatch(setWithdraws(res.data.data));
      }
    } catch (e) {
      openErrorMessage(e);
    }

    setLoading(false);
  }

  async function changeStatus(data) {
    if (loading) return;

    setLoading(true);

    try {
      const res = await WithdrawService.change_withdrawal_status(tokens, data);

      if (res.data.status) {
        dispatch(removeWithdraw(data.withdraw_id));

        toast(res.data.message, { theme: "colored", type: "success" });
      }
    } catch (error) {
      openErrorMessage(error);
    }

    setLoading(false);
  }

  useEffect(() => {
    getUserWithdraws();
  }, []);

  return (
    <div className="responsive-table">
      <table>
        <tr>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Date</th>
          <th>Amount</th>
          <th>Wallet Address</th>
          <th>Action</th>
        </tr>

        {user_withdraws
          .filter((item) => item.status === "Pending")
          .map((item) => (
            <tr key={item.withdraw_id}>
              <td>{item.user.firstname}</td>

              <td>{item.user.lastname}</td>

              <td>{new Date(item.createdAt).toISOString().split("T")[0]}</td>

              <td>{item.amount}</td>

              <td>{item.wallet}</td>

              <td>
                <button
                  className={`kyc_action confirm`}
                  disabled={loading}
                  onClick={() =>
                    changeStatus({
                      withdraw_id: item.withdraw_id,
                      status: "Complete",
                    })
                  }
                >
                  Confirm
                </button>

                <button
                  className={`kyc_action decline`}
                  disabled={loading}
                  onClick={() =>
                    changeStatus({
                      withdraw_id: item.withdraw_id,
                      status: "Declined",
                    })
                  }
                >
                  Decline
                </button>
              </td>
            </tr>
          ))}
      </table>
    </div>
  );
};
